import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import ButtonGradient from "../ui/ButtonGradient";
import EmailInputWithSuggestions from "../emailInputWithSuggestions/EmailInputWithSuggestions";
import { Form, FormTitle, Tabs, Tab } from "../ui/FormBaseStyles";
import Mail from "../../img/form/mail.png";
import Lock from "../../img/form/lock.png";
import InputField from "../inputField/InputField";

const LoginForm = () => {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [formValidated, setFormValidated] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({
    email: false,
    password: false,
  });

  const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitCount((prev) => prev + 1);

    const newErrors = {
      email: formData.email.trim() === "" || !isValidEmail(formData.email),
      password: formData.password.trim() === "",
    };

    setErrors(newErrors);
    setFormValidated(true);

    const hasError = Object.values(newErrors).some(Boolean);
    if (hasError) return;

    // ✅ Simula login bem-sucedido
    login();
    navigate("/logged-home");
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Tabs>
        <Tab onClick={() => navigate("/register")}>Cadastrar</Tab>
        <Tab $active>Logar</Tab>
      </Tabs>

      <FormTitle>Entrar na conta</FormTitle>

      <EmailInputWithSuggestions
        icon={<img src={Mail} alt="ícone email" />}
        label="E-mail"
        name="email"
        placeholder="Escreva seu e-mail"
        required
        value={formData.email}
        onChange={(val: string) => setFormData({ ...formData, email: val })}
        hasError={formValidated && errors.email}
        error={formValidated && errors.email ? "E-mail inválido ou vazio" : ""}
        shakeTrigger={formValidated && errors.email ? submitCount : 0}
      />

      <InputField
        icon={<img src={Lock} alt="ícone senha" />}
        label="Senha"
        name="password"
        placeholder="Escreva sua senha"
        type="password"
        required
        value={formData.password}
        error={formValidated && errors.password ? "Preencha a senha" : ""}
        shakeTrigger={formValidated && errors.password ? submitCount : 0}
        onChange={(e) => setFormData({ ...formData, password: e.target.value })}
      />

      <ButtonGradient type="submit">Entrar</ButtonGradient>
    </Form>
  );
};

export default LoginForm;
